const sizes = {
    veryBigPadding: '22.5px',
    bigPadding: '15px',
    doubleSmallPadding: '12px',
    smallPadding: '6px',
    verySmallPadding: '3px',
    smallViewportDimension: '412px',
    smallViewportDimensionPlusOne: '413px',
    verySmallViewportDimension: '320px',
};

export default sizes;



// WEBPACK FOOTER //
// ./src/style/sizes.js